import React from "react";
import { Dashboard, Login } from "../component";
import HelpPage from "../component/Help/Help";
import Layout from "../component/Layout/index.jsx";
import { AuthLayout } from "../component/Login/AuthLayout";
import Logout from "../component/Logout";
import { lazyDefault, lazyNamed } from "./lazyLoad";
const NotificationMenu = lazyDefault(
  () => import("../component/Notification/NotificationMenu")
);
const Profile = lazyDefault(() => import("../component/Profile"));
const MyProfile = lazyDefault(() => import("../component/Profile/MyProfile"));
const ProfileView = lazyDefault(() => import("../component/Profile/ProfileView"));
const AssignTask = lazyDefault(
  () => import("../component/Programs/ProgramDetails/AssignTask")
);

const PatientRegistrationForm = lazyNamed(
  () => import("../pages/PatientRegistration/PatientRegistrationForm"),
  "PatientRegistrationForm"
);
const MobileInventory = lazyDefault(() => import("../pages/MobileInventory"));
const MobileInventoryForm = lazyDefault(
  () => import("../pages/MobileInventory/form")
);
const MobileInventoryTransfer = lazyDefault(
  () => import("../pages/MobileInventory/transfer")
);
const MobileInventoryDisposal = lazyDefault(
  () => import("../pages/MobileInventory/disposal")
);
const MobileInventoryOrdersList = lazyDefault(
  () => import("../pages/MobileInventory/orders")
);
const MobileInventoryOrdersForm = lazyDefault(
  () => import("../pages/MobileInventory/ordersForm")
);
const MobileMaintenance = lazyDefault(() => import("../pages/MobileMaintenance"));
const InventoryCountsPage = lazyNamed(
  () => import("../pages/InventoryCounts"),
  "InventoryCountsPage"
);
const InventoryCountDetailPage = lazyNamed(
  () => import("../pages/InventoryCounts/CountDetail"),
  "InventoryCountDetailPage"
);
const GlobalSearch = lazyDefault(() => import("../pages/GlobalSearch"));
const FieldStaffAssignmentResponse = lazyDefault(
  () => import("../pages/fieldStaffAssignmentResponse")
);
const FieldStaffAttendance = lazyDefault(
  () => import("../pages/fieldStaffAttendance")
);
const NominationForm = lazyDefault(() => import("../pages/NominationForm"));
const NominationApprovals = lazyDefault(() => import("../pages/NominationTable"));

const PreDeploymentChecklistPage = lazyNamed( () => import("../pages/DeploymentChecklist/PreDeploymentChecklistPage"));
const PostDeploymentChecklistPage = lazyNamed(
  () => import("../pages/DeploymentChecklist/PostDeploymentChecklistPage")
);
const InventoryUsagePage = lazyNamed(
  () => import("../pages/InventoryUsage"),
  "InventoryUsagePage"
);
const SupervisorDeploymentChecklistPage = lazyNamed(
  () => import("../pages/SupervisorDeploymentForm")
);

const ChangePassword = lazyNamed(
  () => import("../component/ChangePassword"),
  "ChangePassword"
);
const ForgotPassword = lazyNamed(
  () => import("../component/ForgotPassword"),
  "ForgotPassword"
);
const VerifyOTP = lazyNamed(() => import("../component/VerifyOTP"), "VerifyOTP");
const Signup = lazyNamed(() => import("../pages/Signup"), "Signup");
const Scheduler = lazyDefault(() => import("../component/Calendar"));
const BulkUpload = lazyDefault(() => import("../pages/BulkUpload"));
const PermissionManagement = lazyDefault(() => import("../pages/PermissionManagement"));
const AuditLogs = lazyDefault(() => import("../pages/AuditLogs"));
const DeploymentComponent = lazyDefault(
  () => import("../component/Deployment/Deployment")
);
const DiscussionDetails = lazyDefault(
  () => import("../component/Discussions/DiscussionDetails")
);
const PageNotFound = lazyDefault(() => import("../component/PageNotFound"));
const Members = lazyDefault(() => import("../component/Members"));
const CreateNewUser = lazyDefault(() => import("../component/Members/CreateNewUser"));
const PaymentCancelled = lazyDefault(
  () => import("../shared/paymentButton/PaymentCancelled")
);
const PaymentSuccessfull = lazyDefault(
  () => import("../shared/paymentButton/payment-successfull")
);
const UpdateMobileUnit = lazyDefault(() => import("../pages/mobileunit/update"));
const ViewPatientDetails = lazyDefault(
  () => import("../pages/PatientRegistration/ViewPatientDetails")
);
const AddMobileUnit = lazyDefault(() => import("../pages/mobileunit/add"));
const MobileUnits = lazyDefault(() => import("../pages/mobileunit"));

const NotificationGroup = lazyDefault(
  () => import("../pages/NotificationGroup")
);
const NotificationGroupForm = lazyDefault(
  () => import("../component/NotificationGroup/NotificationGroupForm")
);
const NotificationGroupView = lazyDefault(
  () => import("../component/NotificationGroup/NotificationGroupView")
);
const InventoryCatalog = lazyDefault(() => import("../pages/InventoryCatalog"));
const InventoryCatalogForm = lazyDefault(
  () => import("../component/InventoryCatalog/InventoryCatalogForm")
);
const DefectManagement = lazyDefault(() => import("../pages/DefectManagement"));
const DefectCreate = lazyDefault(
  () => import("../component/DefectManagement/DefectCreate")
);
const DefectView = lazyDefault(
  () => import("../component/DefectManagement/DefectView")
);
const DefectLogsPage = lazyDefault(
  () => import("../component/DefectManagement/DefectLogsPage")
);
const WorkOrderCreate = lazyDefault(
  () => import("../component/WorkOrder/WorkOrderCreate")
);
const WorkOrderView = lazyDefault(
  () => import("../component/WorkOrder/WorkOrderView")
);
const WorkOrderManagement = lazyDefault(() => import("../pages/WorkOrder"));

const EquipmentFormMapping = lazyDefault(
  () => import("../pages/EquipmentMapping")
);
// const AddSuperMember = lazyDefault(
//   () => import("../component/SuperAdmin/Members/AddSuperMember")
// );
// const SuperMembers = lazyDefault(
//   () => import("../component/SuperAdmin/Members/SuperMembers")
// );

const AdminTimeSheet = lazyDefault(() => import("../component/TimeSheet/adminTimeSheet"));
const FormsDataGrid = lazyDefault(() => import("../component/form_builder/FormsDataGrid"));
const FormBuilderWrapper = lazyDefault(
  () => import("../component/form_builder/FormBuilderWrapper")
);
const DeploymentFormMapping = lazyDefault(
  () => import("../pages/DeploymentFormMapping")
);
const FormLink = lazyDefault(() => import("../component/form_builder/FormLink"));
const MentorProgramTimeSheet = lazyDefault(
  () => import("../component/TimeSheet/mentorProgramTimeSheet")
);
const TimeSheet = lazyDefault(() => import("../component/TimeSheet/timeSheet"));
const Category = lazyDefault(() => import("../component/category"));
const CategoryView = lazyDefault(() => import("../component/category/categoryView"));
const EquipmentHistory = lazyNamed(
  () => import("../component/equipmentManagement/equipmentHistory"),
  "EquipmentHistory"
);
const EquipmentView = lazyDefault(
  () => import("../component/equipmentManagement/viewEquipment")
);

const DocumentUpload = lazyDefault(
  () => import("../component/Mentees/DocumentUpload")
);
const Programs = lazyDefault(() => import("../component/Programs"));
const CreatePrograms = lazyDefault(
  () => import("../component/Programs/CreateProgram")
);
const ProgramCompletion = lazyDefault(
  () => import("../component/Programs/ProgramCompletion")
);
const ProgramDetails = lazyDefault(
  () => import("../component/Programs/ProgramDetails")
);
const IndividualPage = lazyNamed(
  () => import("../component/Questions/IndividualPage"),
  "IndividualPage"
);
const MentorQuestions = lazyDefault(
  () => import("../component/Questions/MentorQuestions")
);
const PaymentPage = lazyDefault(() => import("../component/payments-page/payments"));
const ReportsAnalytics = lazyDefault(
  () => import("../component/Analytics/ReportsAnalytics")
);

/** Layout shells used by the route renderer (not page components). */
export const layoutComponents = {
  auth: AuthLayout,
  default: Layout,
  subheader: (props) => <Layout subheader {...props} />,
};

/**
 * Registry of all routable page components.
 * Keys match the `component` field in route config.
 */
export const routeComponents = {
  EquipmentFormMapping,
  PaymentPage,
  PaymentSuccessfull,
  PaymentCancelled,
  Login,
  Signup,
  ForgotPassword,
  VerifyOTP,
  ChangePassword,
  PatientRegistrationForm,
  PreDeploymentChecklistPage,
  PostDeploymentChecklistPage,
  InventoryUsagePage,
  SupervisorDeploymentChecklistPage,
  FieldStaffAssignmentResponse,
  FieldStaffAttendance,
  NominationForm,
  NominationApprovals,
  // SuperMembers,
  // AddSuperMember,
  Profile,
  HelpPage,
  MentorQuestions,
  // LoginType,
  MobileInventory,
  MobileInventoryForm,
  MobileInventoryTransfer,
  MobileInventoryDisposal,
  MobileInventoryOrdersList,
  MobileInventoryOrdersForm,
  MobileMaintenance,
  InventoryCountsPage,
  InventoryCountDetailPage,
  NotificationGroup,
  NotificationGroupForm,
  NotificationGroupView,
  InventoryCatalog,
  InventoryCatalogForm,
  DefectManagement,
  DefectCreate,
  DefectView,
  DefectLogsPage,
  WorkOrderManagement,
  WorkOrderCreate,
  WorkOrderView,
  Dashboard,
  DocumentUpload,
  BulkUpload,
  PermissionManagement,
  AuditLogs,
  PageNotFound,
  GlobalSearch,
  Programs,
  ProgramDetails,
  ViewPatientDetails,
  AssignTask,
  ProgramCompletion,
  CreatePrograms,
  Scheduler,
  Members,
  CreateNewUser,
  MobileUnits,
  AddMobileUnit,
  UpdateMobileUnit,
  EquipmentView,
  EquipmentHistory,
  DiscussionDetails,
  ProfileView,
  NotificationMenu,
  MyProfile,
  DeploymentComponent,
  // MentorMenteeProfile,
  Category,
  CategoryView,
  // HistoryNotes,
  TimeSheet,
  MentorProgramTimeSheet,
  AdminTimeSheet,
  FormsDataGrid,
  FormBuilderWrapper,
  DeploymentFormMapping,
  ReportsAnalytics,
  IndividualPage,
  FormLink,
  Logout,
};

/** Dynamic props injected from App-level route context. */
export const componentContextProps = {
  PaymentPage: (ctx) => ({ programDetailsId: ctx.programDetailsId }),
  ProgramDetails: (ctx) => ({ setProgramDetailsId: ctx.setProgramDetailsId }),
};
